<template>
  <div class="progress-checker">
    <div class="bars">
      <input
        type="checkbox"
        :checked="value"
        @click="update"
        :style="{ left: getWidth(thisWidth) }"
        :disabled="disabled"
      />
      <div :style="{'background-color': color, width: getWidth(thisWidth) }"></div>
      <div :style="{'background-color': color, width: getWidth(defaultWidth) }"></div>
    </div>
    <div class="content">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "inputer-check-progress",
  props: {
    color: { default: "teal" },
    checkedWidth: { default: 0.1 },
    allWidth: { default: 0 },
    label: { default: "" },
    paths: {},
    disabled: { defalut: false }
  },
  computed: {
    thisWidth() {
      return this.value ? this.checkedWidth : 0;
    },
    defaultWidth() {
      return (this.allWidth > 1 ? 1 : this.allWidth) - this.thisWidth;
    },
    value() {
      return this.$store.getters.getAt(this.paths);
    }
  },
  methods: {
    update() {
      if (this.disabled) return;

      this.$store.commit("update", {
        paths: this.paths,
        value: !this.value
      });
    },
    getWidth(value) {
      return Math.round(value * 100) + "%";
    }
  }
};
</script>

<style lang="sass">
.progress-checker
  position: relative
  height: 1.5rem
  .bars
    position: absolute
    top: 0px
    left: 0px
    bottom: 0px
    right: 0px

    border-radius: 5px
    background-color: #ccc
    font-size: 0
    
    *
      position: absolute
      display: inline-block
      height: 100%
      left: 0

      transition: width 0.5s
      z-index: 1
      &:last-child
        border-radius: 0 5px 5px 0
    input
      position: absolute
      top: -0.1rem
      margin-left: -0.85rem
      width: 1.7rem
      height: 1.7rem

      -webkit-appearance: none
      -moz-appearance: none
      appearance: none
      cursor: pointer
      outline: none

      border: 1px solid #333
      border-radius: 50%
      background-color: #fff
      z-index: 4
      transition: left 0.5s

      &:checked:before
        content: ""

        position: absolute
        left: 10%
        top: 0
        z-index: 1

        width: 100%
        height: 50%

        transform: rotate(-45deg)

        border-width: 4px
        border-color: #4caf50
        border-bottom-style: solid
        border-left-style: solid
        z-index: 5
      & + div
        width: 0%
        border-radius: 5px 0 0 5px
      &:checked + div
        width: 10%
  .content
    position: relative
    display: table
    float: right
    margin:
      top: .25rem
      right: .3rem
    vertical-align: middle

    z-index: 5
</style>
